import { DUBAI_RESORT_CODE, GEOGRAPHY_LEVELS, PRODUCT_TAG_CODES } from "app/constants";

export const generateDestinationTitle = (shop, product, shorten = true) => {
	const { country, region, resort, geography } = product;

	if (shorten || !geography?.levels) {
		const regionToDisplay = shop === "en-GB" && country === "France" ? country : region;

		if (resort && resort !== regionToDisplay) {
			return `${regionToDisplay}, ${resort}`;
		}

		return regionToDisplay;
	}

	const { levels = [] } = geography;
	const lowerCaseLevel = item => item?.level?.toLowerCase();

	const locationArrStr = [];
	const labels = {
		[GEOGRAPHY_LEVELS.DISTRICT]: null,
		[GEOGRAPHY_LEVELS.RESORT]: null,
		[GEOGRAPHY_LEVELS.REGION]: null,
		[GEOGRAPHY_LEVELS.COUNTRY]: null,
	};

	levels.forEach(item => {
		if (labels !== null && labels !== undefined && lowerCaseLevel(item) in labels) {
			labels[lowerCaseLevel(item)] = item?.label;
		}
	});

	Object.entries(labels).forEach(([key, label]) => {
		if (
			label &&
			!(key === GEOGRAPHY_LEVELS.COUNTRY && label === labels[GEOGRAPHY_LEVELS.REGION])
		) {
			locationArrStr.push(label);
		}
	});

	return locationArrStr.join(", ");
};

export const generateHotelName = (hotelName, hotelStars) => {
	return `${hotelName}${hotelStars ? ` ${hotelStars}*` : ""}`;
};

export const getUnbeatableOffer = product => {
	if (!product?.merchandisings?.some(tag => tag.startsWith("GC"))) {
		return undefined;
	}

	const endAt = new Date(product?.endAt);
	const now = new Date();
	const sevenDaysFromNow = new Date();
	sevenDaysFromNow.setDate(now.getDate() + 7);

	if (endAt > sevenDaysFromNow) {
		return PRODUCT_TAG_CODES.LIMITED_TIME;
	}

	return PRODUCT_TAG_CODES.LAST_DAY;
};

export const getAccommodationsWithDiscount = accommodations => {
	return accommodations?.map(accommodation => {
		return Number(accommodation?.discountValue) > 0
			? {
					...accommodation,
					merchandisings: Array.from(
						new Set([
							...(accommodation?.merchandisings ?? []),
							PRODUCT_TAG_CODES.DISCOUNT,
						])
					),
				}
			: accommodation;
	});
};

export const getIsDubaiProduct = geography =>
	geography?.levels?.some(level => level.code === DUBAI_RESORT_CODE);
